import { css } from 'styled-components';
import { OnlineButtonProps } from '@sunbit-dev/web-ui-lib';

export const ActionButton = css<OnlineButtonProps>(({ theme }) => {
  return css`
    max-width: 310px;
    min-width: 180px;
    width: 50%;
    flex-shrink: 0;
    margin: auto auto 0;

    @media only screen and ${theme.device.max.mobileXL} {
      width: 100%;
    }
  `;
});
